import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import favorites_gen_2 from '@devices/settings/device_settings/favorites_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import safety_cover_gen_2 from '@devices/settings/device_settings/safety_cover_gen_2.js';
import roller_app_setting_gen_2 from '@devices/settings/device_settings/roller_app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import shutter_settings_gen_3 from '../device_settings/shutter_settings_gen_3';
import bluetooth_bt_home_control_gen_2 from '../device_settings/bluetooth_bt_home_control_gen_2';

export default [
	schedule_gen_2,
	webhooks_gen_2,
	addon_sensors,
	scripts_gen_2,
	networks_gen_2_plus,
	bluetooth_bt_home_control_gen_2,
	favorites_gen_2,
	virtual_components,
	safety_cover_gen_2,
	roller_app_setting_gen_2,
	share,
	shutter_settings_gen_3,
];
